/**
 * Auth Error Constants
 * Centralized error types and messages for authentication flow
 */
export const AUTH_ERROR_CODES = {
    // Session errors
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    SESSION_INVALID: 'SESSION_INVALID',
    SESSION_MISSING: 'SESSION_MISSING',
    // Authentication errors
    AUTH_FAILED: 'AUTH_FAILED',
    TOKEN_INVALID: 'TOKEN_INVALID',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    // Authorization errors
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    INSUFFICIENT_PERMISSIONS: 'INSUFFICIENT_PERMISSIONS',
    // Configuration errors
    CONFIG_MISSING: 'CONFIG_MISSING',
    WORKOS_CONFIG_INVALID: 'WORKOS_CONFIG_INVALID',
    // Network errors
    NETWORK_ERROR: 'NETWORK_ERROR',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    // Widget errors
    WIDGET_TOKEN_FAILED: 'WIDGET_TOKEN_FAILED',
    ORGANIZATION_MISSING: 'ORGANIZATION_MISSING',
};
/**
 * Error message constants returned by the API
 * These match the error messages sent from the backend
 */
export const API_ERROR_MESSAGES = {
    INVALID_SESSION_COOKIE: 'Invalid session cookie',
};
export const AUTH_ERROR_MESSAGES = {
    [AUTH_ERROR_CODES.SESSION_EXPIRED]: 'Your session has expired. Please sign in again.',
    [AUTH_ERROR_CODES.SESSION_INVALID]: 'Invalid session. Please sign in again.',
    [AUTH_ERROR_CODES.SESSION_MISSING]: 'No active session found. Please sign in.',
    [AUTH_ERROR_CODES.AUTH_FAILED]: 'Authentication failed. Please try again.',
    [AUTH_ERROR_CODES.TOKEN_INVALID]: 'Invalid authentication token.',
    [AUTH_ERROR_CODES.TOKEN_EXPIRED]: 'Authentication token has expired.',
    [AUTH_ERROR_CODES.UNAUTHORIZED]: 'Access denied. Authentication required.',
    [AUTH_ERROR_CODES.FORBIDDEN]: 'Access denied. Insufficient permissions.',
    [AUTH_ERROR_CODES.INSUFFICIENT_PERMISSIONS]: 'You do not have permission to perform this action.',
    [AUTH_ERROR_CODES.CONFIG_MISSING]: 'Authentication configuration is missing.',
    [AUTH_ERROR_CODES.WORKOS_CONFIG_INVALID]: 'WorkOS configuration is invalid or missing.',
    [AUTH_ERROR_CODES.NETWORK_ERROR]: 'Network error occurred during authentication.',
    [AUTH_ERROR_CODES.SERVICE_UNAVAILABLE]: 'Authentication service is temporarily unavailable.',
    [AUTH_ERROR_CODES.WIDGET_TOKEN_FAILED]: 'Failed to generate widget token.',
    [AUTH_ERROR_CODES.ORGANIZATION_MISSING]: 'No organization ID available for this operation.',
};
export class AuthenticationError extends Error {
    constructor(code, details) {
        const message = AUTH_ERROR_MESSAGES[code];
        super(message);
        this.name = 'AuthenticationError';
        this.code = code;
        this.details = details;
        this.timestamp = new Date();
    }
    toJSON() {
        return {
            code: this.code,
            message: this.message,
            details: this.details,
            timestamp: this.timestamp,
        };
    }
}
//# sourceMappingURL=auth-errors.js.map